module.exports = __webpack_public_path__ + "static/media/picturetopeople.org-9537672f96421e64dba3b711181b39e25b67b6f3352f25505b.cb5de16e.png";